// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__m8o_f","errorBox":"style_errorBox__DwPWG"};